export default __webpack_public_path__ + "static/media/delivery.c68f1f65.svg";